<template>
    <div >
      <Card>
            <p slot="title">
                Bank Account Group
            </p>
                <Button
                    v-show="canCreateBankAccount()"
                    type="primary"
                    slot="extra"
                    @click="modal.createBankAccount=true"
                    size="small"  >
                    Tambah
                </Button>
                <template>
                        <Table border :columns="columnTableBankAccount" :data="bankAccountGroup"></Table>

                </template>
        </Card>
        <template>
            <Modal v-model="modal.createBankAccount" width="500px">
                <p slot="header" style="color:#2d8cf0;text-align:center">
                    <Icon type="information-circled"></Icon>
                    <span>Tambah Bank Account</span>
                </p>
                      <Form ref="formBankAccount" :model="formBankAccount" :rules="ruleValidate">
                        <Form-item label="Group Name" prop="groupName">
                            <Input v-model="formBankAccount.groupName" placeholder="Group Name"></Input>
                        </Form-item>
                        <Form-item>
                            <Select
                                placeholder="Ketik Marking"
                                v-model="formBankAccount.banks"
                                filterable
                                multiple
                                >
                                <Option v-for="(option, index) in ListBankAccount"
                                    :value="option.value" :key="index">{{option.label}}</Option>
                            </Select>
                        </Form-item>
                      </Form>
                <div slot="footer">
                    <Button
                        v-show="true"
                        type="primary"
                        :loading="loadingCreateBankAccount"
                        @click="postCreateBankAccount" >
                        <span v-if="!loadingCreateBankAccount">Simpan</span>
                        <span v-else>Wait.....</span>
                    </Button>
                </div>
            </Modal>
        </template>
        <template>
            <Modal v-model="modal.updateBankAccount" width="500px">
                <p slot="header" style="color:#2d8cf0;text-align:center">
                    <Icon type="information-circled"></Icon>
                    <span>Edit Item</span>
                </p>

                <Form ref="formUpdateBankAccount" :model="formUpdateBankAccount" :rules="ruleValidate">
                        <Form-item label="Group Name" prop="groupName">
                            <Input v-model="formUpdateBankAccount.groupName" placeholder="Group Name"></Input>
                        </Form-item>
                        <Form-item>
                            <Select
                                placeholder="Ketik Account"
                                v-model="formUpdateBankAccount.banks"
                                filterable
                                multiple
                                :remote-method="getBankAccount"
                                >
                                <Option v-for="(option, index) in ListBankAccount"
                                    :value="option.value" :key="index">{{option.label}}</Option>
                            </Select>
                        </Form-item>
                      </Form>

                <div slot="footer">
                    <Button
                        v-show="true"
                        type="primary"
                        :loading="loadingUpdateBankAccount"
                        @click="postUpdateBankAccount" >
                        <span v-if="!loadingUpdateBankAccount">Update</span>
                        <span v-else>Wait.....</span>
                    </Button>
                </div>
            </Modal>
            <Modal v-model="modal.deleteAccountGroup" ok-text="Ya" cancel-text="Tidak" @on-cancel="confirmDescription = ''">
              <p slot="header" style="color:#f60;text-align:center">
                <Icon type="information-circled"></Icon>
                <span>Konfirmasi</span>
            </p>
            <br/>
            <div>
                <h4>GROUP NAME : {{formDeleteGroup.groupName}}</h4> <hr/>
                <div>
                  <b> Account : </b>
                  <span v-for="(value, index) in formDeleteGroup.banks">
                      <Tag>{{ value.bank_account.accountName }}</Tag>
                  </span>
                </div> <br/>
                <i> Ketik <b>{{ formDeleteGroup.groupName }}</b> untuk melanjutkan !</i>

                <Input v-model="formDeleteGroup.id" style="display: none;"></Input>
                <Input v-model="formDeleteGroup.groupName" style="display: none;"></Input>
                <Input v-model="confirmDescription" />
            </div>

            <div slot="footer">
                <Button type="error" long v-show="(formDeleteGroup.groupName).toUpperCase() == confirmDescription.toUpperCase()" :loading="loadingDeleteBankAccount" @click="deleteAccountGroup">Hapus</Button>
            </div>
            </Modal>
        </template>
    </div>
</template>
<script>
import {HTTP} from '@/components/http-lib'
import _ from 'lodash'

const numeral = require('numeral');

export default {
    data () {
        return {
        user : {
            username : '',
            role : ''
        },
        modal : {
            createBankAccount : false,
            updateBankAccount : false,
            deleteAccountGroup: false,
        } ,
        loadingSearch: false,
        loadingCreateBankAccount: false,
        loadingUpdateBankAccount: false,
        loadingDeleteBankAccount: false,
        bankAccountGroup : [],
        ListBankAccount: [],
        confirmDescription: '',
        formBankAccount: {
          groupName: '',
          banks: []
        },
        formUpdateBankAccount: {
            id: '',
            groupName: '',
            banks: []
        },
        formDeleteGroup: {
          id: '',
          groupName: '',
          banks: []
        },
        ruleValidate: {
            groupName: [
                { required: true, message: 'Masukkan Group Name', trigger: 'blur' }
            ],
            banks: [
            { required: true, message: 'Masukkan Account', trigger: 'blur' }
            ]
        },
        columnTableBankAccount: [
            {
                title: 'Group Name',
                key: 'bank_group_name',
                width: 150
            },
            {
              title: "Total Mutasi",
              key: "total_mutation",
              width:  130
            },
            {
              title: 'List Acount',
              key: "bank_group_detail",
              render: (h, params) => {
                console.info('param', params)

                let list = []

                params.row.bank_group_detail.forEach(element => {

                  let type = "default"

                  list.push(h('Button', {
                    props:{
                      type: type,
                      size: "small"
                    },
                    style: {
                      marginRight: "5px",
                      marginTop: "3px",
                      marginBottom: "3px"
                    }
                  }, element.bank_account.accountName))
                })

                return h('div', list)
              },
            },
            {
                title: 'Action',
                key: 'action',
                width: 180,
                align: 'center',
                render: (h, params) => {
                    let buttonToShow = [
                            h('Button', {
                                props: {
                                    type: 'success',
                                    size: 'small'
                                },
                                style: {
                                    marginRight: '5px'
                                },
                                on: {
                                    click: () => {
                                        this.show(params.index, 'updateBankAccount')
                                    }
                                }
                            }, 'Edit')
                    ];

                    buttonToShow.push(h('Button', {
                        props: {
                            type: 'error',
                            size: 'small'
                        },
                        on: {
                            click: () => {
                              this.show(params.index, 'deleteAccountGroup')
                            }
                        }
                    }, 'Delete'))
                  return h('div', buttonToShow);
                }
            }
        ],
    }},

  methods: {
    canCreateBankAccount () {
        let canAccess = _.includes(['SUPERVISOR', 'ADMINISTRATOR'], this.user.role);
        return canAccess;
    },
    handleSubmit (name) {
        this.$refs[name].validate((valid) => {
            if (valid) {
                this.createbankAccount();
            } else {
                this.$Message.error('Data masih belum lengkap');
            }
        })
    },
    show: function(index, modalName){
      var BankAccount = this.bankAccountGroup[index];

        if(modalName == "updateBankAccount") {
          this.formUpdateBankAccount.id = BankAccount.id;
          this.formUpdateBankAccount.groupName = BankAccount.bank_group_name;
          this.formUpdateBankAccount.banks = BankAccount.bank_group_detail.map(o => o.bank_account_id);
          this.modal.updateBankAccount = true;
          return
        }

        if(modalName == "deleteAccountGroup") {
          console.info(BankAccount)
          this.formDeleteGroup.id = BankAccount.id
          this.formDeleteGroup.groupName = BankAccount.bank_group_name
          this.formDeleteGroup.banks = BankAccount.bank_group_detail
            this.modal.deleteAccountGroup = true;
        }
    },
    getBankAccountGroup: function(){
        this.loadingSearch  = true;
        this.bankAccount = []
        HTTP
            .get('bank/group/all')
            .then(response => {

                let accountGroup = response.data.map(o => {
                console.info(numeral(o.total_mutation).format('0,0'))
                return {...o, total_mutation: numeral(o.total_mutation).format('0,0')}
              })
              console.info('bankAccountGroup', accountGroup)

                this.loadingSearch  = false;
                this.bankAccountGroup = accountGroup
            })
            .catch(e => {
            this.$Notice.error({
                title: "Error",
                desc: e,
                duration: 5
            });
        })
    },
    getBankAccount: function(){
        this.loadingSearch  = true;
        this.bankAccount = []
        HTTP
            .get('bankAccount/findAll')
            .then(response => {
                this.loadingSearch  = false;
                console.info('result.data', response.data)
                // this.bankAccount = response.data
                let result = []
                response.data.forEach(element => {
                  result.push({
                    label: element.accountName,
                    value: element.id
                  })
                });
                this.ListBankAccount = result
                return result
            })
            .catch(e => {
            this.$Notice.error({
                title: "Error",
                desc: e,
                duration: 5
            });
        })
    },
    postCreateBankAccount:function(){
            this.loadingCreateBankAccount = true;
      console.info(this.formBankAccount)
            if(this.formBankAccount.groupName.trim() === "") {
                this.$Message.error('Account name tidak boleh kosong');
                this.loadingCreateBankAccount = false;
                return false;
            }

            let accountNameExist = _.some(this.bankAccountGroup, {bank_group_name: this.formBankAccount.groupName });

            if(accountNameExist){
                this.$Message.error('Account name sudah ada');
                this.loadingCreateBankAccount = false;
                return false;
            }

            let bank_accounts = []

            this.formBankAccount.banks.forEach(value => {
              bank_accounts.push({
                bank_account_id: value
              })
            })

            HTTP
            .post('bank/group/create', {
              bank_group_name: this.formBankAccount.groupName,
              bank_accounts: bank_accounts
            })
            .then(response => {
                this.loadingCreateBankAccount = false;
                this.modal.createBankAccount = false;
                this.formBankAccount.groupName = '';

                this.$Message.success('Bank Account Created');
                this.getBankAccountGroup();
            })
            .catch(e => {
                this.loadingCreateBankAccount = false;
                this.$Notice.error({
                    title: "Error",
                    desc:e,
                    duration: 5
                });
            })
    },
    postUpdateBankAccount:function(){
            this.loadingUpdateBankAccount = true;

            if(this.formUpdateBankAccount.groupName.trim() === "") {
                this.$Message.error('Account name tidak boleh kosong');
                this.loadingUpdateBankAccount = false;
                return false;
            }

            let bankAccount = this.formUpdateBankAccount.banks.map(o => {
              return {bank_account_id: o}
            })
            HTTP
            .put('bank/group/update', {
              bank_group_id: this.formUpdateBankAccount.id,
              bank_group_name: this.formUpdateBankAccount.groupName  ,
              bank_accounts: bankAccount
            })
            .then(response => {
                this.loadingUpdateBankAccount = false;
                this.modal.updateBankAccount = false;
                this.formUpdateBankAccount.accountName = '';

                this.$Message.success('Bank Account Updateed');
                this.getBankAccountGroup();
            })
            .catch(e => {
                this.loadingUpdateBankAccount = false;
                this.$Notice.error({
                    title: "Error",
                    desc:e,
                    duration: 5
                });
            })
    },
    deleteAccountGroup: function() {
      console.info('deleteAccountGroup', this.modal.deleteAccountGroup)
      let id = this.formDeleteGroup.id
      this.loadingDeleteBankAccount = true
      HTTP
      .delete('bank/group/delete/' + id)
      .then(response => {
        this.loadingDeleteBankAccount = false
        this.modal.deleteAccountGroup = false;

        this.$Message.success('Bank Account Deleted');
        this.getBankAccountGroup();
      })
      .catch(e => {
        this.modal.deleteAccountGroup = false
        this.loadingDeleteBankAccount = false
          this.$Notice.error({
              title: "Error",
              desc:e,
              duration: 5
          });
      })
    },
  },
  created() {
      this.user.username = localStorage.getItem('user.username')
      this.user.role = localStorage.getItem('user.role')
      this.getBankAccountGroup();
      this.getBankAccount()
  }
}
</script>
<style>

</style>



// WEBPACK FOOTER //
// BankAccountGroup.vue?88e3ff6c